import { render, staticRenderFns } from "./ModifyWechatUser.vue?vue&type=template&id=54436731&scoped=true"
import script from "./ModifyWechatUser.vue?vue&type=script&lang=js"
export * from "./ModifyWechatUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54436731",
  null
  
)

export default component.exports